// extracted by mini-css-extract-plugin
export var slipBody = "SlipBody-module--slipBody--3da9b";